import { Component } from '@angular/core';
import { LoadingSpinner } from 'design-system';

// Attesa del template precompilato: l'azione torna disponibile a download finito
@Component({
  selector: 'ord-new-customer-preparing',
  imports: [LoadingSpinner],
  template: `
    <div class="preparing">
      <ui-loading-spinner />
      <div class="preparing-text">
        <span class="body-medium-emphasized">Preparazione del template...</span>
        <span class="body-small">L'azione sarà di nuovo disponibile al termine del download</span>
      </div>
    </div>
  `,
  styles: `
    :host {
      display: block;
    }

    .preparing {
      display: flex;
      align-items: center;
      gap: var(--mat-sys-spacing-16);
      padding: var(--mat-sys-spacing-12);
      border-radius: var(--mat-sys-corner-medium);
      color: var(--mat-sys-on-surface);
      background-color: var(--mat-sys-surface-bright);
    }

    .preparing-text {
      display: grid;
      gap: var(--mat-sys-spacing-4);
      min-width: 0;
    }
  `,
})
export class NewCustomerPreparing {}
